<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>

<div class='content'>
  
  <ng-template [ngIf]="!loaderpaymet">
  <div style="text-align: center;" *ngIf="paymenterror; else notInclude" >
    <div class='fa fa-check-circle-o symbol'></div> 
    <div class='title'><h3>Transaction successful</h3></div>
    <br>
    <a style="font-size: 1.5rem;" routerLink="/">Back to home</a>
    <div class='text'></div>
  </div>
    <ng-template #notInclude>
    <div class='fa fa-times-circle-o symbolerror'></div>  
    <div class='title'><h3>Transaction Failed </h3></div>
    <br>
    <a style="font-size: 1.5rem;" routerLink="/">Back to home</a>
    <div class='text'></div>
  
    </ng-template>
    </ng-template>
  </div>